import { Toaster } from "react-hot-toast";
import "./App.css";
import MainRoutes from "./routes/MainRoutes";
import { useEffect } from "react";
import SubscriptionPopupHost from "./components/SubscriptionPopupHost";
import PlanLimitHost from "./components/PlanLimitHost";
import AnalysisWatcherHost from "./components/AnalysisWatcherHost";
import NotificationHost from "./components/Notifications/NotificationHost";


function App() {
  // Ensure every external (http/https) link opens in a new tab, no matter how
  // it was rendered (chat HTML, markdown, static anchors). In-page anchors
  // (e.g. "#source_viewer") and SPA navigation are intentionally left alone.
  useEffect(() => {
    const handleClick = (e) => {
      const anchor =
        e.target && e.target.closest ? e.target.closest("a") : null;
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href) return;
      if (/^https?:\/\//i.test(href) && anchor.target !== "_blank") {
        anchor.target = "_blank";
        anchor.rel = "noopener noreferrer";
      }
    };
    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);

  return (
    <div className="App w-full">
      <MainRoutes />
      <NotificationHost />
      <AnalysisWatcherHost />
      <SubscriptionPopupHost />
      <PlanLimitHost />
      <Toaster
        position="bottom-right"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          // Long file names have no spaces; let them wrap instead of running off the toast.
          style: { maxWidth: 420, overflowWrap: "anywhere", wordBreak: "break-word" },
          duration: 3000,
          success: { duration: 3000 },
          error: { duration: 4000 },
          loading: { duration: 10000 },
        }}
      />
    </div>
  );
}

export default App;
